import { useShowSuccess, useShowError } from 'hooks/useToast'
import { useCreateInventoryLocationMutation } from '../../../../graphql'

export default function useCreateInventoryLocationHandler( options?: any ) {
	const [ createStore ] = useCreateInventoryLocationMutation( options )
	const showSuccess = useShowSuccess()
	const showError = useShowError()

	return async( branchId: number, name: string ) => {
		const result = await createStore( { variables: {
			branchId,
			name,
		} } )
		if ( result.data?.createInventoryLocation?.success ) {
			showSuccess( `createInventoryLocationSuccess${Date.now()}`, result.data?.createInventoryLocation?.message ?? 'Successfully created store!' )
		} else {
			showError( `createInventoryLocationError${Date.now()}`, result.data?.createInventoryLocation?.message ?? 'Sorry, an error occurred' )
		}
	}
}
